// @ts-strict-ignore
import { Component, Input, OnInit } from '@angular/core';
import { ArticleVO } from '@article/model/vo/article.vo';
import { BsModalRef } from 'ngx-bootstrap/modal';

@Component({
  standalone: false,
  selector: 'app-switching-rails-problems',
  templateUrl: './switching-rails-problems.component.html'
})
export class SwitchingRailsProblemsComponent implements OnInit {

  @Input() unconnectableArticlesToShow: ArticleVO[];
  public unconnectableArticles: ArticleVO[];
  public unconnectableArticleNumbers: string[] = [];

  constructor(private bsModalRef: BsModalRef) {}

  ngOnInit(): void {
    this.unconnectableArticles = this.unconnectableArticlesToShow;
    this.updateUnconnectableArticleNumbers();
  }
  private updateUnconnectableArticleNumbers(): void {
    if (!this.unconnectableArticles || this.unconnectableArticles.length === 0) {
      this.unconnectableArticleNumbers = [];
    } else {
      const result: string[] = [];
      for (const unconnectableArticle of this.unconnectableArticles) {
        if (result.indexOf(unconnectableArticle.articleNo) === -1) {
          result.push(unconnectableArticle.articleNo);
        }
      }
      this.unconnectableArticleNumbers = result;
    }
  }

  public close(): void {
    this.bsModalRef.hide();
  }
}
